import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { NavbarComponent } from './navbar/navbar.component';
import {SharedModule} from '../shared/shared.module';
import {TranslateService} from '@ngx-translate/core';
import {DrawerModule} from './drawer/drawer.module';
import {MatListModule} from '@angular/material';
import {FooterComponent, FooterModule} from './footer/footer.component';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { ContentViewerComponent } from './content-viewer/content-viewer.component';
import {NavItems} from './nav-items/nav-items';

@NgModule({
  imports: [
    CommonModule,
    LayoutRoutingModule,
    SharedModule,
    DrawerModule,
    FooterModule
  ],
  exports: [
    DrawerModule,
    FooterModule,
    NavbarComponent,
    ContentHeaderComponent,
    ContentViewerComponent
  ],
  providers: [
    TranslateService,
    NavItems
  ],
  declarations: [NavbarComponent, ContentHeaderComponent, ContentViewerComponent]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/layout.module.ts